import { RecordVoiceOverOutlined } from '@mui/icons-material';
import { Alert, Divider, Grid } from '@mui/material';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';
import { formatDateRange } from '../../../utils/dateFormat';

type VeranstaltungsReferentenProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsReferentenComponent = ({ veranstaltung }: VeranstaltungsReferentenProps) => (
  <CustomAccordion title="Referenten" open icon={RecordVoiceOverOutlined}>
    {veranstaltung.experteBlockungen.length === 0 && <Alert severity="info">Keine Referenten vorhanden</Alert>}
    {veranstaltung.experteBlockungen.map((experteBlockung, i) => (
      <>
        <div key={experteBlockung.id} style={{ marginBottom: '12px', marginTop: '12px' }}>
          <span style={{ display: 'block', marginBottom: '6px' }}>
            <b>
              {experteBlockung.experte?.vorname ?? 'Unbekannt'} {experteBlockung.experte?.nachname ?? ''}
            </b>
          </span>
          <Grid container spacing={1} rowSpacing={-5}>
            <Grid size={5}>Referenten-ID:</Grid>
            <Grid size={7}>
              <b>{experteBlockung.experteId}</b>
            </Grid>
            <Grid size={5}>Zeitraum:</Grid>
            <Grid size={7}>
              <div key={experteBlockung.id}>
                <b>{formatDateRange(new Date(experteBlockung.start), new Date(experteBlockung.ende))}</b>
              </div>
            </Grid>
            <Grid size={5}>Mail:</Grid>
            <Grid size={7}>
              <b />
            </Grid>
          </Grid>
        </div>
        {i + 1 !== veranstaltung.experteBlockungen.length && <Divider />}
      </>
    ))}
  </CustomAccordion>
);
